// All properties sorted alphabetically.
export enum LoggingEventCategory {
  ai = 'AI',
  error = 'error',
  sw = 'SW',
}

// All properties sorted alphabetically.
export enum LoggingEvent {
  BreadcrumbCategory = 'breadcrumb-category',
  BreadcrumbSubCategory = 'breadcrumb-sub-category',
  CategoryClick = 'category-click',
  error = 'error',
  exception = 'exception',
  ExternalLinkClick = 'external-link',
  FeedbackAnswered = 'feedback-answered',
  FeedbackPromptDismissed = 'feedback-prompt-dismissed',
  FeedbackPromptVisible = 'feedback-prompt-visible',
  FeedbackShareUrlClick = 'feedback-share-url-click',
  FooterContactClick = 'footer-contact-click',
  FooterTelegramClick = 'footer-telegram-click',
  FooterWhatsAppClick = 'footer-whatsapp-click',
  LanguageOptionsClose = 'language-options-close',
  LanguageOptionsOpen = 'language-options-open',
  MainScreenClick = 'main-screen-button-click',
  NotFoundCategory = 'not-found-category',
  NotFoundOffer = 'not-found-offer',
  NotFoundQA = 'not-found-qa',
  NotFoundParentQuestion = 'not-found-parent-question',
  NotFoundParentQuestionIsSelf = 'not-found-parent-question-is-self',
  NotFoundSheetRows = 'not-found-sheet-rows',
  NotFoundSubCategory = 'not-found-sub-category',
  NotificationDismissed = 'notification-dismissed',
  OfferClick = 'offer-click',
  OfferDetailClick = 'offer-detail-click',
  ParentLinkClick = 'parent-link-click',
  Print = 'print',
  QuestionClose = 'question-close',
  QuestionOpen = 'question-open',
  SubCategoryClick = 'sub-category-click',
  SwUpdateActivated = 'sw-update-activated',
  SwUpdateAvailable = 'sw-update-available',
  SwUpdateNotActivated = 'sw-update-not-activated',
  SwUpdateNotAvailable = 'sw-update-not-available',
}
